export default __webpack_public_path__ + "static/media/celular.82326004.png";